export default {
      id: "icon-instagram-usage",
      viewBox: "0 0 47.239 47.239",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-instagram",
      toString: function () {
        return this.url;
      }
    }